import thainight2 from '../../assets/Events/thainight2.jpg'
import thainight3 from '../../assets/Events/thainight3.jpg'
import thainight4 from '../../assets/Events/thainight4.jpg'
import thainight5 from '../../assets/Events/thainight5.jpg'
import thainight6 from '../../assets/Events/thainight6.jpg'
import thainight7 from '../../assets/Events/thainight7.jpg'

export const thaiNight = [
    {
        name: 'Thai Night 2020',
        img: thainight2
    },
    {
        name: 'Thai Night 2020',
        img: thainight3
    },
    {
        name: 'Thai Night 2020',
        img: thainight4
    },
    {
        name: 'Thai Night 2020',
        img: thainight5
    },
    {
        name: 'Thai Night 2020',
        img: thainight6
    },
    {
        name: 'Thai Night 2020',
        img: thainight7
    },
]